angular.module("vgresiduos").controller("HomePageCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "", getQueries());
		};

		function getQueries() {
			return [{ key: "menu", value: $stateParams.menu }];
		}
	}
]);
